import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
  HostListener,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DynamicdashboardService } from 'src/app/services/dynamicdashboard.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ProductivityService } from 'src/app/services/productivity-service';
import { Options } from 'highcharts';
import { Chart } from 'angular-highcharts';
import { NgxSpinnerService } from 'ngx-spinner';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { ReplaySubject, Subject, Subscription, timer } from 'rxjs';
import { map, share, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ButtonDeleteRendererComponent } from 'src/app/components/button-delete-render.components';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import More from 'highcharts/highcharts-more';
import ExportData from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
import moment from 'moment';
import { DynamicChart } from 'src/app/services/dynamic-chart';
import {
  ConfirmDialogModel,
  ConfirmationDialogComponent,
} from 'src/app/components/confirmation-dialog/confirmation-dialog/confirmation-dialog.component';
// import * as jsPDF from 'jspdf';
import jsPDF from 'jspdf';

import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_fullscreen from 'highcharts/modules/full-screen';
import { AtStagesNcrComponent } from 'src/app/analytical-tools/at-stages-ncr/at-stages-ncr.component';
import { CustomBottomSheetComponent } from '../dashboard/custom-bottom-sheet/custom-bottom-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BaseApi } from 'src/backend/api/base-api';
import { CommonService } from 'src/app/services/common.service';
import { PriorityLevel } from 'src/@smartmanufacturing/common/enum';
HC_more(Highcharts);
HC_exporting(Highcharts);
More(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
Accessibility(Highcharts);
HC_fullscreen(Highcharts);

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  protected _onDestroy = new Subject<void>();
  @ViewChild('AddCardPoup') private addCardPopup!: TemplateRef<any>;
  @ViewChild('FilterPoup') private FilterPoup!: TemplateRef<any>;
  @ViewChild('addActionModal') private addActionModal!: TemplateRef<any>;
  @ViewChild('addImageInput') addImageInput!: ElementRef;
  @ViewChild('addFileInput') addFileInput!: ElementRef;
  @ViewChild('AddTabPoup') private addTabPoup!: TemplateRef<any>;
  @ViewChild('allSelected') private allSelected: MatSelect;
  @ViewChild('container', { static: false }) container: ElementRef;
  @ViewChild('createAction', { static: true })
  private createAction: TemplateRef<any>;
  public valueSearchCtrl: FormControl = new FormControl();
  public filteredValueMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  chart: Highcharts.Chart;
  format = 'YYYY-MM-DD HH:mm:ss';
  chartOptions: any;
  dynamicChart: any;
  public openMenu: boolean = false;
  allSelectedOptions = false;
  isOver = false;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  userDetails!: any;
  CardListTop: any[] = new Array();
  CardListLeft: any[] = new Array();
  CardListRight: any[] = new Array();
  dataPointList: any[] = new Array();
  chartList: any[] = new Array();
  filteredDataPoints: any;
  isPopupOpen: boolean = false;
  AddCardform!: FormGroup;
  Headerform!: FormGroup;
  addActionForm!: FormGroup;
  AddTabform!: FormGroup;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  requestType: string = 'All';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredDynamicValues: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  isLoadingLines: boolean = false;
  unitList!: any[];
  isLoadingUnits: boolean = false;
  chartArray: any[] = [];
  chartArrayRight: any[] = [];
  options: Options;
  chartLeftData: any[] = new Array();
  chartRightData: any[] = new Array();
  chartLeftCategory: any[] = new Array();
  chartRightCategory: any[] = new Array();
  updateCard: boolean = false;
  updateValues: any;
  isChangingDatapoint: boolean = false; // Flag to track when user is changing datapoint
  activeButton!: any;
  Frequency: string = 'Monthly';
  DataExist: boolean = false;
  IsTabExist: boolean = false;
  addImageSrc = '';
  addStatus = 'Open';
  addFile = null;
  addImage = null;
  targetDate: any;
  RevisedDate: Date;
  addFileSrc = '';
  userList: any = [];
  clock = new Date();
  subscription: Subscription;
  intervalId;
  time = new Date();
  tourStep: number = 0;
  AggeregateList!: any[];
  FabOptions = {
    buttons: [
      {
        icon: 'timeline',
      },
      {
        icon: 'view_headline',
      },
      {
        icon: 'room',
      },
      {
        icon: 'lightbulb_outline',
      },
      {
        icon: 'lock',
      },
    ],
  };
  chats = [{ isBot: true, message: 'Hi, how can I help you?' }];
  userInput = '';
  isOnInitLoad: boolean = false;
  lang: any;
  tabs: any[] = new Array();
  dataPointSources: any[] = new Array();
  dynamicListByDatasource: any[] = new Array();
  sourceName: string = 'Common DataPoints';
  sourceId: number = 1;
  selectedTabIndex;
  rowData!: any[];
  rowDataPO!: any[];
  rowDataAM!: any[];
  rowDataAction!: any[];
  columnDefs!: any[];
  columnDefsProcessOrder!: any[];
  columnDefsAM!: any[];
  columnDefsAction!: any[];
  gridApi!: any;
  gridColumnApi!: any;
  public frameworkComponents: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      filter: true,
    },
  };
  savedFilterData: any = [];
  lastUpdatedWidth: any = 0;
  selectedFilter: any;
  static dialog: any;
  static createActionref: TemplateRef<any>; // Declare the property
  static selectedChartValue: any;
  static chartProp: any;
  KPIId: any;
  numbersArray: any;
  currentShiftOEE: Chart;
  YesterdayOEE: Chart;
  lastOEE: Chart;
  userMachines: any = [];
  filteredUser: any;
  groupSession: any;
  plantSession: any;
  userObj: any;
  userMenus: any;
  userFilter: any;
  infoContent: string =
    'Number of Days: This function calculates and stores the number of days between a specified start date and an end date. It always returns a date range, starting from the current date and extending backwards for the calculated number of days.-----   Date Range: This function saves a specific date range as selected by the user. It then returns this exact date range whenever requested, maintaining the same start and end dates as originally selected.';
  mClassificationTypes: any[] = [];
  Levels = [
    { Id: PriorityLevel.High, Name: 'High' },
    { Id: PriorityLevel.Medium, Name: 'Medium' },
    { Id: PriorityLevel.Low, Name: 'Low' },
  ];

  // Custom validator to ensure at least one of timeperiod or defaultFilter is selected
  private atLeastOneRequired(group: FormGroup): { [key: string]: boolean } | null {
    const timeperiod = group.get('timeperiod')?.value;
    const defaultFilter = group.get('defaultFilter')?.value;
    
    if (!timeperiod && !defaultFilter) {
      return { atLeastOneRequired: true };
    }
    return null;
  }

  // Private method to validate date ranges
  private validateDates(): { isValid: boolean; error?: string } {
    const startDate = new Date(this.AddCardform.value.dateStart);
    const endDate = new Date(this.AddCardform.value.dateEnd);
    
    // Set today to end of day to allow selecting today's date
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    
    // Check if start date is in the future
    if (startDate > today) {
      return { 
        isValid: false, 
        error: 'Start date cannot be in the future!' 
      };
    }
    
    // Check if start date is before end date
    if (startDate >= endDate) {
      return { 
        isValid: false, 
        error: 'Start date must be earlier than end date!' 
      };
    }
    
    return { isValid: true };
  }

  constructor(
    private dynamicService: DynamicdashboardService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    public translater: TranslaterService,
    private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private actionplanService: OverallActionPlanService,
    public router: Router,
    private bottomSheet: MatBottomSheet,
    private baseApi: BaseApi,
    private commonService: CommonService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    LandingPageComponent.dialog = dialog;
  }

  ngOnInit(): void {
    //this.getSavedFilter();
    this.getSessionData();
    this.getLangWords();
    this.getMClassificationList();
    // getting current logged in user
    let userdataJson: any = localStorage.getItem('user');
    this.userDetails = JSON.parse(userdataJson);
    this.initForm();
    // const savedLayout = localStorage.getItem('myDraggableLayout');
    // if (savedLayout) {
    //   const layout = JSON.parse(savedLayout) as string[];
    //   this.chartArrayRight.sort((a, b) => layout.indexOf(a.id) - layout.indexOf(b.id));
    // }
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);

    // Using RxJS Timer
    this.subscription = timer(0, 1000)
      .pipe(
        map(() => new Date()),
        share()
      )
      .subscribe((time) => {
        let hour = this.clock.getHours();
        let minuts = this.clock.getMinutes();
        let seconds = this.clock.getSeconds();
        //let a = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
        let NewTime = hour + ':' + minuts + ':' + seconds;
        //console.log(NewTime);
        this.clock = time;
      });

    this.frameworkComponents = {
      buttonDeleteRenderer: ButtonDeleteRendererComponent,
    };
    this.columnDefs = [
      { headerName: 'Id', field: 'Id' },
      {
        headerName: 'Tab Name',
        field: 'TabName',
        editable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonDeleteRenderer',
        cellRendererParams: {
          onClick: this.confirmDialog.bind(this),
          label: 'Delete',
        },
        maxWidth: 85,
        suppressMenu: true,
      },
    ];

    this.getTabs();
    this.valueSearchCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterValue();
      });
    this.getLine();
    // this.getUserMachineList();
    // this.setProfileData();
  }
onDateChanged() {
  
  this.AddCardform.get('defaultFilter')?.setValue(null);
}
  filterValue(): void {
    if (!this.filteredDynamicValues) {
      return;
    }
    let search = this.valueSearchCtrl.value;
    if (!search) {
      this.filteredValueMulti.next(this.filteredDynamicValues);
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredValueMulti.next(
      this.filteredDynamicValues.filter(
        (value: any) => value.Name.toLowerCase().indexOf(search) > -1
      )
    );
  }

  clickMenu() {
    this.openMenu = !this.openMenu;
  }

  hello(mex: string) {
    alert('Hello ' + mex + '!');
  }

  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : this.translate.currentLang === 'gr'
                  ? 5
                  : this.translate.currentLang === 'du'
                    ? 6
                    : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }

  initForm() {
    const dateStart = new Date();
    //dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);
    const dateEnd = new Date();
    this.AddCardform = this.formBuilder.group({
      labelName: ['', [Validators.required]],
      datapointName: ['', [Validators.required]],
      analysisUrl: [],
      orderNo: [],
      chartType: ['', [Validators.required]],
      Id: [],
      values: [],
      source: [],
      // UserGroup1: ['', Validators.required],
      // UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      aggregates: [],
      timeperiod: ['noofdays'], // Optional - either timeperiod OR defaultFilter required
      defaultFilter: [''], // Optional - either timeperiod OR defaultFilter required
    }, { validators: this.atLeastOneRequired.bind(this) });

    dateEnd.setDate(dateEnd.getDate());
    this.Headerform = this.formBuilder.group({
      // UserGroup1: ['', Validators.required],
      // UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      frequency: ['', Validators.required],
      Id: [''],
    });

    this.addActionForm = this.formBuilder.group({
      id: [''],
      action: ['', Validators.required],
      actionType: ['', Validators.required],
      assignTo: ['', Validators.required],
      targetDate: ['', Validators.required],
      priorityLevel: ['', Validators.required],
      mClassification: [],
      kpi: [''],
    });

    this.AddTabform = this.formBuilder.group({
      tabName: ['', Validators.required],
    });

    this.Headerform.get('frequency').setValue('Monthly');
    // this.datasource();
  }

onFilterChange(event: any) {

  const endDate = new Date();
  const startDate = new Date(endDate);
  const selectedFilter = event.value;

  switch (selectedFilter) {
    case 'daily':
      startDate.setDate(endDate.getDate() - 1);
      break;

    case 'weekly':
      startDate.setDate(endDate.getDate() - 7);
      break;

    case 'monthly':
      startDate.setMonth(endDate.getMonth() - 1);
      break;

    case 'yearly':
      startDate.setFullYear(endDate.getFullYear() - 1);
      break;
  }

  this.AddCardform.patchValue({
    dateStart: startDate,
    dateEnd: endDate,
    defaultFilter: selectedFilter,
    timeperiod: null  // Deselect timeperiod when defaultFilter is selected
  });
}

onTimePeriodChange(event: any) {
  // When timeperiod is selected, deselect defaultFilter
  if (event.value) {
    this.AddCardform.patchValue({
      defaultFilter: null
    });
  }
}
  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    const user = this.baseApi.getUserSession();
    this.userObj = this.baseApi.getUserSession();
    this.userMenus = this.baseApi.getUserPermissionsSession();
    this.pageId = this.baseApi.getCurrentMenuID();
  }
  previousUnitSelection: number[] = [];
previousLineSelection: number[] = [];

onChangeLine(event: any): void {
  const selectedValues: number[] = event.value || [];
  const control = this.AddCardform.get('line');

  const allIds = this.lineList.map(x => x.PL_Id); 
  const itemIds = allIds.filter(id => id !== 0);

  const hadAll = this.previousLineSelection.includes(0);
  const hasAll = selectedValues.includes(0);

  if (hasAll && !hadAll) {
    control?.setValue(allIds);
    this.previousLineSelection = [...allIds];
    return;
  }

  if (!hasAll && hadAll) {
    control?.setValue([]);
    this.previousLineSelection = [];
    return;
  }

  const allItemsSelected = itemIds.every(id =>
    selectedValues.includes(id)
  );

  if (allItemsSelected && !hasAll) {
    control?.setValue(allIds);
    this.previousLineSelection = [...allIds];
    return;
  }

  if (hasAll && !allItemsSelected) {
    const newValues = selectedValues.filter(id => id !== 0);

    control?.setValue(newValues);
    this.previousLineSelection = [...newValues];
    return;
  }

  this.previousLineSelection = [...selectedValues];
}
 
  // onChangePlant(data: any): void {
  //   this.getLine(data.value);
  //   this.getUserList();
  //   this.getDataPointSourceList();
  // }

  //===================================================header dd code ========================================================//
onChangeUnit(event: any): void {

  const selectedValues: number[] = event.value || [];
  const control = this.AddCardform.get('unit');

  const allIds = this.unitList.map(x => x.PU_Id);
  const itemIds = allIds.filter(id => id !== 0);

  const hadAll = this.previousUnitSelection.includes(0);
  const hasAll = selectedValues.includes(0);

  // Select All
  if (hasAll && !hadAll) {

    control?.setValue(allIds);

    this.previousUnitSelection = [...allIds];
    return;
  }

  // Unselect All
  if (!hasAll && hadAll) {

    control?.setValue([]);

    this.previousUnitSelection = [];
    return;
  }

  // Select all one by one
  const allItemsSelected = itemIds.every(id =>
    selectedValues.includes(id)
  );

  if (allItemsSelected && !hasAll) {

    control?.setValue(allIds);

    this.previousUnitSelection = [...allIds];
    return;
  }

  // Remove one item while All selected
  if (hasAll && !allItemsSelected) {

    const newValues = selectedValues.filter(id => id !== 0);

    control?.setValue(newValues);

    this.previousUnitSelection = [...newValues];
    return;
  }

  this.previousUnitSelection = [...selectedValues];
}
getSelectedUnitsText(): string {

  const selectedIds = this.AddCardform.get('unit')?.value || [];
 if (!this.unitList?.length) {
    return '';
  }
  return this.unitList
    .filter(x =>
      x.PU_Id !== 0 &&
      selectedIds.includes(x.PU_Id)
    )
    .map(x => x.PU_Desc)
    .join(', ');
}
  async getLine(): Promise<void> {
    const key = {
      PlantCode: this.plantSession.plantCode,
      userCode: this.userObj.userCode,
    };

    this.isLoadingLines = true;
    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        this.lineList = [
  {
    PL_Id: 0,
    PL_Desc: 'All'
  },
  ...this.lineList
];
        if (this.lineList.length > 0) {
          if (!this.updateCard) {
    this.AddCardform.get('line')?.patchValue([]);
    this.previousLineSelection = [];
}
        // this.AddCardform.get('line').patchValue([]);
          // const lineDefault = this.lineList[0].PL_Id;
          // this.updateCard === true
          //   ? this.AddCardform.get('line').patchValue(this.updateValues.LineId)
          //   : this.AddCardform.get('line').patchValue(lineDefault);
          // this.filteredLines = this.lineList.slice();
          // this.getUnit(lineDefault.PL_Id);
        }
        this.isLoadingLines = false;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.isLoadingLines = false;
      }
    );
  }
  getSelectedLinesText(): string {

  const selectedIds = this.AddCardform.get('line')?.value || [];
  if (!this.lineList?.length) {
    return '';
  }
  return this.lineList
    .filter(x => x.PL_Id !== 0 && selectedIds.includes(x.PL_Id))
    .map(x => x.PL_Desc)
    .join(', ');
}
onLineDropdownClosed(): void {
  const selectedLines = this.AddCardform.get('line')?.value || [];
// If no lines are selected, do nothing
  if (!selectedLines.length) {
    return;
  }

  this.getUnitOnlineChange(selectedLines);
}
  async getUnit(id: number): Promise<void> {
    const key = {
      PL_ID: this.AddCardform.value.line,
      userCode: this.userObj.userCode,
    };

    this.isLoadingUnits = true;
    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
           this.unitList = [
        {
          PU_Id: 0,
          PU_Desc: 'All'
        },
        ...data.lstUnit
      ];

      this.filteredUnits = [...this.unitList];
          this.updateCard === true
            ? this.AddCardform.get('unit').patchValue(this.updateValues.UnitId)
            : this.AddCardform.get('unit').patchValue('0');
          this.filteredUnits = this.unitList.slice();
        }
        this.isLoadingUnits = false;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.isLoadingUnits = false;
      }
    );
  }

  getUnitOnlineChange(selectedLines: Array<number>): void {
    const key = {
      PL_ID: selectedLines.includes(0)
      ? '0'
      : selectedLines.join(','),
      userCode: this.userObj.userCode,
    };

    this.isLoadingUnits = true;
    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
          this.unitList = [
        {
          PU_Id: 0,
          PU_Desc: 'All'
        },
        ...data.lstUnit
      ];
        if (this.unitList.length > 0) {
          this.filteredUnits = [...this.unitList];

      this.AddCardform.get('unit')?.patchValue([]);
      this.previousUnitSelection = [];
         
          
        
        }
        this.isLoadingUnits = false;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.isLoadingUnits = false;
      }
    );
  }
  checkDataExist() {
    if (
      this.CardListTop.length === 0 &&
      this.CardListLeft.length === 0 &&
      this.CardListRight.length === 0
    ) {
      this.DataExist = true;
    } else {
      this.DataExist = false;
    }
  }

  saveFilter(): void {
    const key = {
      TransactionType: this.Headerform.value.Id === '' ? 1 : 2,
      startDate: this.Headerform.value.dateStart,
      endDate: this.Headerform.value.dateEnd,
      GroupId: this.groupSession.groupCode,
      PlantId: this.plantSession.plantCode,
      UnitId: this.Headerform.value.unit,
      LineId: this.Headerform.value.line,
      frequency: this.Headerform.value.frequency,
      Id: this.Headerform.value.Id !== 0 ? this.Headerform.value.Id : 0,
    };
    this.spinner.show();
    this.dynamicService.saveUserFilterData(key).subscribe(
      (data: any) => {
        this.toaster.success('Success', data.Table[0].Msg);
        this.spinner.hide();
        this.getSavedFilter();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  deleteFilter(): void {
    this.spinner.hide();
    this.dynamicService.deleteSavedFilter().subscribe(
      (data: any) => {
        this.toaster.success('Success', data.Table[0].Msg);
        this.spinner.hide();
        this.getSavedFilter();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  getSavedFilter(): void {
    this.resetList();
    this.spinner.show();
    this.dynamicService.getFilterData().subscribe(
      (data: any) => {
        this.savedFilterData = data;
        this.isOnInitLoad = true;
        if (data.Table.length > 0) {
          // this.Headerform.get('UserGroup1').setValue(data.Table[0].group);
          // this.Headerform.get('UserPlant1').setValue(data.Table[0].plant);
          this.Headerform.get('line').setValue(data.Table[0].line);
          this.Headerform.get('unit').setValue(data.Table[0].machine);
          this.Headerform.get('dateStart').setValue(data.Table[0].start_date);
          this.Headerform.get('dateEnd').setValue(data.Table[0].end_date);
          this.Headerform.get('frequency').setValue(data.Table[0].frequency);
          this.Headerform.get('Id').setValue(data.Table[0].id);
          this.spinner.hide();
        } else {
          this.isOnInitLoad = true;
          this.spinner.hide();
          // this.getCardList();
          // this.getCardListLeft();
          // this.getCardListRight();
        }
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  //======================================================END ================================================================//

  //================================================== fetch Dashboard Data ======================================//
  async getCardList(): Promise<void> {
    const key = {
      cardLocation: 'top',
      tabIndexId: this.tabs[0]?.Id,
    };
    await this.dynamicService.getCardList(key).then(
      (data: any) => {
        this.resetList();
        data.cardList.forEach((element) => {
          this.getTopCardData(element);
        });
        this.checkDataExist();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  getTopCardData(element): any {
    const key = {
      dtStartDate: element.startDate,
      dtEndDate: element.endDate,
      GroupId:
        element.GroupId !== null
          ? element.GroupId
          : this.groupSession.groupCode,
      PlantId:
        element.PlantId !== null
          ? element.PlantId
          : this.plantSession.plantCode,
      UnitId:
        element.UnitId !== null ? element.UnitId : this.AddCardform.value.unit,
      LineId:
        element.LineId !== null ? element.LineId : this.AddCardform.value.line,
      dataPointId: element.dataPointId,
      Frequency: '',
      Id: element.Id,
      Shift: '*',
    };
    this.dynamicService.getTopCardData(key).subscribe(
      (data: any) => {
        const dataObj = {
          labelName: data[0].labelName,
          uom: data[0].uom,
          imagePath: data[0].imagePath,
          result: data[0].result,
          dataPointId: data[0].dataPointId,
          chartType: data[0].chartType,
          cardLocation: data[0].cardLocation,
          Id: data[0].Id,
          orderNo: data[0].orderNo,
          source: data[0].source,
          sourceValues: data[0].sourceValues,
          GroupId: data[0].GroupId,
          PlantId: data[0].PlantId,
          LineId: data[0].LineId,
          UnitId: data[0].UnitId,
          startDate: data[0].startDate,
          endDate: data[0].endDate,
          aggregates: data[0].aggregates,
          timeperiod: data[0].timeperiod,
          defaultFilter: data[0].timeFilter 
        };
        this.insertCardTop(dataObj);
        this.checkDataExist();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  insertCardTop(newCard) {
    const index = this.CardListTop.findIndex(
      (card) => card.orderNo > newCard.orderNo
    );

    if (index === -1) {
      this.CardListTop.push(newCard);
    } else {
      this.CardListTop.splice(index, 0, newCard);
    }
  }

  async getCardListRight(): Promise<void> {
    this.CardListRight = [];
    const key = {
      cardLocation: 'right',
      tabIndexId: this.tabs[0]?.Id,
    };
    await this.dynamicService.getCardList(key).then(
      (data: any) => {

        debugger;
        this.CardListRight = [];
        this.CardListRight = data.cardList;
        this.CardListRight.forEach((obj) => {
          //obj.width = 60 ;
          obj.isMaximized = false;
          obj.addedFrom = 'personalized';
          // Map timeFilter/timefilter to defaultFilter for consistency
          obj.defaultFilter = obj.defaultFilter;
        });
        this.plotRightChart();
        this.checkDataExist();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  resetList() {
    this.CardListTop = [];
    this.CardListLeft = [];
    this.CardListRight = [];
  }

  resetForm(): void {
    this.AddCardform.get('labelName').reset(),
      this.AddCardform.get('datapointName').reset(),
      this.AddCardform.get('analysisUrl').reset(),
      this.AddCardform.get('orderNo').reset(),
      this.AddCardform.get('chartType').reset(),
      this.AddCardform.get('source').reset(),
      this.AddCardform.get('values').reset(),
      this.AddCardform.get('dateStart').reset(),
      this.AddCardform.get('dateEnd').reset();
      this.AddCardform.get('unit').reset();
      this.AddCardform.get('line').reset();
      this.AddCardform.get('defaultFilter').reset();
      this.previousLineSelection = [];
      this.previousUnitSelection = [];
  }

  changeFilter(): void {
    if (this.requestType === 'top') {
      this.getCardList();
    } else if (this.requestType === 'right') {
      this.getCardListRight();
    } else {
      this.getCardList();
      this.getCardListRight();
    }
  }

  openPopup(request: string) {
    this.resetForm();
    this.updateCard = false;
    // Set the card type before the dialog renders and before the source list loads,
    // otherwise the previously opened card's layout/sources leak into this one
    this.requestType = request;
    this.sourceName = '';
    this.dataPointSources = [];
    this.chartList = [];
    this.dataPointList = [];
    this.filteredDataPoints = [];
    this.dynamicListByDatasource = [];
    this.filteredDynamicValues = [];
    this.filteredValueMulti.next([]);
    if (this.requestType === 'top') {
      this.AddCardform.get('chartType')?.setValue('value');
    }
    let dialogRef = this.dialog.open(this.addCardPopup, {
      minWidth: '60%',
      minHeight: '50%',
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.isPopupOpen = false;
    });
    this.getDataPointSourceList();
  }

  openTabPopup() {
    this.AddTabform.reset();
    let dialogRef = this.dialog.open(this.addTabPoup, {
      minWidth: '35%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => { });
    dialogRef.afterClosed().subscribe((res: any) => { });
  }

  FilterPopup(request: string) {
    let dialogRef = this.dialog.open(this.FilterPoup, {
      minWidth: '35%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      this.requestType = request;
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.isPopupOpen = false;
    });
  }

  openFilterPopup(request: string) {
    let dialogRef = this.dialog.open(this.FilterPoup, {
      minWidth: '35%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      this.requestType = request;
      if (this.requestType === 'top') {
        this.getCardList();
      } else if (this.requestType === 'right') {
        this.getCardListRight();
      } else {
        this.getCardList();
        this.getCardListRight();
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.isPopupOpen = false;
    });
  }

  navigateToAnalysisScreen(item: any): void {
    this.toaster.info('Analysis URL not define');
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.AddCardform.controls[controlName].hasError(errorName);
  };

  getDataPointList(): void {
    const itemToCheck = this.chartList.find(
      (val) => val.Value === this.AddCardform.get('chartType').value
    )?.valueType;
    const key = {
      datatype: this.requestType === 'top' ? 'value' : itemToCheck,
    };
    this.dynamicService.getDataPointList(key).subscribe(
      (data: any) => {
        this.dataPointList = data.dataList;
        this.filteredDataPoints = this.dataPointList.slice();
        this.AddCardform.get('datapointName').patchValue(
          this.dataPointList[0]?.Id
        );
        this.AddCardform.get('labelName')?.setValue(
          this.dataPointList[0]?.Name
        );
        if (this.updateCard === true) {
          this.AddCardform.get('datapointName').patchValue(
            this.updateValues.dataPointId
          );
        }
        this.getDDBySourceList();
        this.getAggregatesList();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  getChartList() {
    const params = {
      sourceId: this.AddCardform.get('source').value,
    };
    this.dynamicService.getChartList(params).subscribe(
      (data: any) => {
        this.chartList = data.Table;
        if (this.requestType !== 'top') {
          this.AddCardform.get('chartType').patchValue(this.chartList[0].Value);
        }
        if (this.updateCard === true) {
          this.AddCardform.get('chartType').patchValue(
            this.updateValues.chartType
          );
        }
        this.getDataPointList();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  saveDashboardCard() {
    if (!this.AddCardform.valid) {
      // Check if the error is the atLeastOneRequired validator
      if (this.AddCardform.errors?.['atLeastOneRequired']) {
        this.toaster.warning('Please select either Time Period or Default Filter!');
      } else {
        this.toaster.warning('Kindly fill the required fields!');
      }
      return;
    }

    // Validate date ranges
    const validation = this.validateDates();
    if (!validation.isValid) {
      this.toaster.warning(validation.error!);
      return;
    }

    const data = {
      TransactionType: 1,
      Id: 0,
      labelName: this.AddCardform.get('labelName').value,
      datapointId: this.AddCardform.get('datapointName').value,
      analysisUrl:
        this.AddCardform.get('analysisUrl').value === null
          ? ''
          : this.AddCardform.get('analysisUrl').value === null,
      orderNo:
        this.AddCardform.get('orderNo').value === null
          ? 100
          : this.AddCardform.get('orderNo').value,
      chartType: this.AddCardform.get('chartType').value,
      cardLocation: this.requestType,
      tabIndexId: this.tabs[0]?.Id,
      source: this.AddCardform.get('source').value,
      sourceValues: JSON.stringify(this.AddCardform.get('values').value),
      startDate: this.AddCardform.value.dateStart,
      endDate: this.AddCardform.value.dateEnd,
      GroupId: this.groupSession.groupCode,
      PlantId: this.plantSession.plantCode,
      UnitId: this.AddCardform.value.unit.includes(0)
  ? '0'
  : this.AddCardform.value.unit.join(','),
      LineId: this.AddCardform.value.line.includes(0)
  ? '0'
  : this.AddCardform.value.line.join(','),
      aggregates: this.AddCardform.value.aggregates,
      timeperiod: this.AddCardform.value.timeperiod,
      defaultFilter: this.AddCardform.get('defaultFilter')?.value || '',
    };
    this.spinner.show();
    this.dynamicService.saveDashboardCard(data).subscribe(
      (data: any) => {
        this.toaster.success('Success', data.ErrorMessage);
        if (this.requestType === 'top') {
          this.getCardList();
          this.dialog.closeAll();
        } else {
          this.getCardListRight();
          this.dialog.closeAll();
        }
        this.spinner.hide();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  deleteDashboardCard(obj): void {
    const message = `Are you sure you want to delete this card ?`;

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      maxWidth: '600px',
      width: '450px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.deleteTopCard(obj);
      } else {
        console.log(dialogResult);
      }
    });
  }

  deleteTopCard(Item) {
    const data = {
      TransactionType: 2,
      Id: Item.Id,
      labelName: this.AddCardform.get('labelName').value,
      datapointId: 0,
      analysisUrl:
        this.AddCardform.get('analysisUrl').value === null
          ? ''
          : this.AddCardform.get('analysisUrl').value === null,
      orderNo: Item.orderNo,
      startDate: this.AddCardform.value.dateStart,
      endDate: this.AddCardform.value.dateEnd,
      GroupId: this.groupSession.groupCode,
      PlantId: this.plantSession.plantCode,
    }
    this.dynamicService.saveDashboardCard(data).subscribe(
      (data: any) => {
        this.toaster.success('Success', 'Card deleted successfully');
        this.getCardList();
        this.dialog.closeAll();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  deleteDashboardCardRight(obj): void {
    
    const message = `Are you sure you want to delete this chart ?`;

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      maxWidth: '600px',
      width: '450px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.deleteRightCard(obj);
      } else {
        console.log(dialogResult);
      }
    });
  }

  deleteRightCard(Item) {
    
    const data = {
      TransactionType: 2,
      Id: Item.Item.Id,
      labelName: this.AddCardform.get('labelName').value,
      datapointId: 0,
      analysisUrl:
        this.AddCardform.get('analysisUrl').value === null
          ? ''
          : this.AddCardform.get('analysisUrl').value === null,
      orderNo: Item.orderNo,
      startDate: this.AddCardform.value.dateStart,
      endDate: this.AddCardform.value.dateEnd,
      GroupId: this.groupSession.groupCode,
      PlantId: this.plantSession.plantCode
    }

    this.dynamicService.saveDashboardCard(data).subscribe(
      (data: any) => {
        this.toaster.success('Success', 'Chart deleted successfully');
        this.getCardListRight();
        this.dialog.closeAll();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  //===============================================Updates Calls ============================================================//
  changeDatapoint(Obj: any): void {
    debugger;
    this.resetForm();
    this.requestType = Obj.cardLocation;
    this.updateCard = true;
    this.getDataPointSourceList();
    this.getLine();
    this.updateValues = Obj;
    this.sourceId = Obj.source;
    
    // Parse and set line values with tracking update
    let selectedLines = [];
    const splitedLines = Obj.LineId.split(',');
    if (splitedLines.includes('0')) {
      const ids = this.lineList.map(x => x.PL_Id);
      selectedLines = ids;
    } else {
      selectedLines = splitedLines.map(Number);
    }
    
    this.AddCardform.get('line').patchValue(selectedLines);
    this.previousLineSelection = [...selectedLines];
  
    // Load units based on selected lines, then set unit values
    this.getUnitOnlineChange(Obj.LineId.split(',').map(Number));

    // Wait for units to load then patch values
    setTimeout(() => {
      let selectedUnits = [];
      const splitedUnits = Obj.UnitId.split(',');
      if (splitedUnits.includes('0')) {
        const ids = this.unitList.map(x => x.PU_Id);
        selectedUnits = ids;
      } else {
        selectedUnits = splitedUnits.map(Number);
      }
      this.AddCardform.get('unit')?.patchValue(selectedUnits);
      this.previousUnitSelection = [...selectedUnits];
    }, 2000);
    
    this.AddCardform.get('dateStart').patchValue(Obj.startDate);
    this.AddCardform.get('dateEnd').patchValue(Obj.endDate);
    this.AddCardform.get('timeperiod').patchValue(Obj.timeperiod);
    // Map timeFilter/timefilter or defaultFilter from backend
    const filterValue = Obj.defaultFilter;
    this.AddCardform.get('defaultFilter').patchValue(filterValue);
    // this.AddCardform.get('aggregates').patchValue(Obj.aggregates);
    let dialogRef = this.dialog.open(this.addCardPopup, {
      minWidth: '50%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      // this.getChartList();
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.isPopupOpen = false;
      this.updateCard = false;
    });
  }

  updateDashboardCard() {
    if (!this.AddCardform.valid) {
      // Check if the error is the atLeastOneRequired validator
      if (this.AddCardform.errors?.['atLeastOneRequired']) {
        this.toaster.warning('Please select either Time Period or Default Filter!');
      } else {
        this.toaster.warning('Kindly fill the required fields!');
      }
      return;
    }

    // Validate date ranges
    const validation = this.validateDates();
    if (!validation.isValid) {
      this.toaster.warning(validation.error!);
      return;
    }

    const data = {
      TransactionType: 3,
      Id: this.AddCardform.get('Id').value,
      labelName: this.AddCardform.get('labelName').value,
      datapointId: this.AddCardform.get('datapointName').value,
      analysisUrl:
        this.AddCardform.get('analysisUrl').value === null
          ? ''
          : this.AddCardform.get('analysisUrl').value === null,
      orderNo: this.AddCardform.get('orderNo').value,
      chartType: this.AddCardform.get('chartType').value,
      cardLocation: this.requestType,
      source: this.AddCardform.get('source').value,
      sourceValues: JSON.stringify(this.AddCardform.get('values').value),
      startDate: this.AddCardform.value.dateStart,
      endDate: this.AddCardform.value.dateEnd,
      GroupId: this.groupSession.groupCode,
      PlantId: this.plantSession.plantCode,
    UnitId: this.AddCardform.value.unit.includes(0)
  ? '0'
  : this.AddCardform.value.unit.join(','),
LineId: this.AddCardform.value.line.includes(0)
  ? '0'
  : this.AddCardform.value.line.join(','),
      aggregates: this.AddCardform.value.aggregates,
      timeperiod: this.AddCardform.value.timeperiod,
      defaultFilter: this.AddCardform.get('defaultFilter')?.value || '',
    };
    this.spinner.show();
    this.dynamicService.saveDashboardCard(data).subscribe(
      (data: any) => {
        this.toaster.success('Success', data.ErrorMessage);
        if (this.requestType === 'top') {
          this.getCardList();
          this.dialog.closeAll();
        } else {
          this.getCardListRight();
          this.dialog.closeAll();
        }
        this.spinner.hide();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  setLabel(data) {
    const obj = this.dataPointList.find((val) => val.Id === data.value);
    this.AddCardform.get('labelName')?.setValue(obj.Name);
    this.isChangingDatapoint = true; // Set flag to prevent label override
    this.getDDBySourceList();
    // Reset flag after getDDBySourceList completes
    setTimeout(() => {
      this.isChangingDatapoint = false;
    }, 500);
  }
  //===============================================END====================================================================//

  //============================================== plot chart code here ==============================================//

  plotRightChart(): void {
    this.chartArrayRight = [];
    this.CardListRight.forEach(async (element: any) => {
      const chartObj = { Item: {}, chartOption: {} };
      const key = {
        cardLocation: 'right',
        dtStartDate: element.startDate,
        dtEndDate: element.endDate,
        GroupId: this.groupSession.groupCode,
        PlantId:
          element.PlantId !== null
            ? element.PlantId
            : this.plantSession.plantCode,
        UnitId:
          element.UnitId !== null
            ? element.UnitId
            : this.AddCardform.value.unit,
        LineId:
          element.LineId !== null
            ? element.LineId
            : this.AddCardform.value.line,
        dataPointId: element.dataPointId,
        Frequency: '',
        Id: element.Id,
        shift: '*',
        timeFilter: element.defaultFilter ,
      };

      await this.dynamicService.getRightCardList(key).then((data: any) => {
        const title = element.labelName;
        this.chartRightData = [];
        this.chartRightCategory = [];
        if (element.chartType === 'pie') {
          data.Table.forEach((val) => {
            this.chartRightData.push({ name: val.name, y: val.result });
          });
        } else if (element.chartType === 'drilldown') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.drawDrillDownChart(data, element));
          return;
        } else if (element.chartType === 'lineComparision') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.drawLineComparison(data, element));
          return;
        } else if (element.chartType === 'columnComparison') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(
            this.dynamicChart.drawColumnComparison(data, element)
          );
          return;
        } else if (element.chartType === 'StockLineComparison') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.drawLineComparison(data, element));
          return;
        } else if (element.chartType === '3dDonutChart') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.draw3dDonut(data, element));
          return;
        } else if (element.chartType === '3dColumnChart') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.draw3dColumn(data, element));
          return;
        } else if (element.chartType === '3dPieChart') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.draw3dPie(data, element));
          return;
        } else if (element.chartType === 'donut') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.drawDonut(data, element));
          return;
        } else if (element.chartType === 'stacked') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.stackedchart(data, element));
          return;
        } else if (element.chartType === 'spline') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.splineChart(data, element));
          return;
        } else if (element.chartType === 'solidgauge') {
          this.dynamicChart = new DynamicChart();
          this.insertCard(this.dynamicChart.drawGauge(data, element));
          return;
        } else {
          data.Table.forEach((val) => {
            this.chartRightData.push({ name: '', y: val.result });
            this.chartRightCategory.push(val.name);
          });
        }

        // create the chart
        this.options = {
          title: {
            text: title,
            style: {
              fontWeight: 'bold', // Makes the title bold
            },
          },
          credits: {
            enabled: false,
          },
          xAxis: {
            categories: this.chartRightCategory,
           
          },
          yAxis: {
            // min: 0,
            // max: 100,
            // labels: {
            //   format: '{value}%'
            // }
          },
          tooltip: {
            enabled: true,
            style: {
              zIndex: 100,
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return '<span style="font-size: 10px; font-weight: normal">' +
                    this.point.name ===
                    undefined
                    ? this.y.toFixed(2)
                    : this.point.name + ' ' + this.y.toFixed(2) + ' </span>';
                },
              },
              events: {
                click: LandingPageComponent.openActionsModel.bind(
                  this,
                  element
                ),
              },
            },
          },
          series: [
            {
              name: title,
              type: element.chartType,
              colorByPoint: true,
              data: this.chartRightData,
            },
          ],
        };
        let chart = new Chart(this.options);
        chartObj.chartOption = chart;
        chartObj.Item = element;
        //this.chartArrayRight.push(chartObj);
        this.insertCard(chartObj);
      });
    });
  }

  insertCard(newCard) {
    const index = this.chartArrayRight.findIndex(
      (card) => card.Item.orderNo > newCard.Item.orderNo
    );

    if (index === -1) {
      this.chartArrayRight.push(newCard);
    } else {
      this.chartArrayRight.splice(index, 0, newCard);
    }
  }

  showPhase(event: any) {
    this.activeButton = event;
  }

  // as of now not in use

  weekly() {
    this.Frequency = 'Weekly';
    this.plotRightChart();
  }
  monthly() {
    this.Frequency = 'Monthly';
    this.plotRightChart();
  }

  removeCharactersTillSymbol(str: string): string {
    const indexOfSymbol = str.indexOf('-');
    if (indexOfSymbol === -1) {
      return str;
    } else {
      return str.substring(indexOfSymbol + 1);
    }
  }

  checkKPIId(kpiId: number) {
    const KPI = this.dynamicListByDatasource?.filter(
      (obj) =>
        this.removeCharactersTillSymbol(obj.Name) ===
        LandingPageComponent.chartProp.point.series.name
    );
    KPI.forEach((obj) => {
      if (obj.Id === kpiId) {
        this.KPIId = obj.Id;
      }
    });
  }

  addActionPlan(): void {
    this.targetDate = this.addActionForm.value.targetDate;
    this.targetDate = new Date(this.targetDate);
    this.targetDate.setHours(new Date().getHours());
    this.targetDate.setMinutes(new Date().getMinutes());
    this.targetDate.setSeconds(new Date().getSeconds());
    if (this.numbersArray.length > 1) {
      this.numbersArray.forEach((obj: any) => {
        this.checkKPIId(parseInt(obj));
      });
    }
    let status =
      this.addActionForm.value.targetDate &&
        !this.addActionForm.value.revisedDate
        ? 'InProgress'
        : this.addActionForm.value.targetDate &&
          this.addActionForm.value.revisedDate
          ? 'Delayed'
          : 'Open';
    if (this.addActionForm.value.verification === 'Approved') {
      status = 'Closed';
      // fiveWhy.ClosedDate = new Date();
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      status = 'ReOpened';
      // fiveWhy.ActionCompleted = 'No';
      this.addActionForm.get('completed').setValue('No');
    }

    const key = {
      ActionName: this.addActionForm.value.action,
      ActionType: this.addActionForm.value.actionType,
      Responsible: this.addActionForm.value.assignTo,
      priorityLevel: this.addActionForm.value.priorityLevel,
      mClassification: this.addActionForm.value?.mClassification,
      TargetDate: this.targetDate,
      Status: status,
      userCode: this.userObj.userCode,
      plantCode: LandingPageComponent.selectedChartValue.PlantId,
      meetingStatus: 2,
      meetingId: LandingPageComponent.selectedChartValue.Id,
      kpiId: this.KPIId,
    };
    this.spinner.show();
    this.actionplanService.addActionPlan(key).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res?.data[0]?.message === 'Add Successfully') {
          this.toaster.success('Sucess', 'Added Successfully');
          this.dialog.closeAll();
          // this.getOverallMeetingActions();
          // this.addActionForm.reset();
          // this.addActionForm.get('actionType')?.setValue('Corrective');
          // this.addActionForm.get('kpi')?.setValue(this.KPIName);
        }
      },
      error: ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', '');
      },
    });
    this.resetAction();
  }

  resetAction() {
    this.addActionForm.reset();
  }

  openAddActionModal() {
    // this.AddCardform.get('UserGroup1').patchValue(LandingPageComponent.selectedChartValue.GroupId);
    // this.AddCardform.get('UserPlant1').patchValue(LandingPageComponent.selectedChartValue.PlantId);
    this.AddCardform.get('line').patchValue(
      LandingPageComponent.selectedChartValue.LineId
    );
    this.AddCardform.get('unit').patchValue(
      LandingPageComponent.selectedChartValue.UnitId
    );
    this.sourceName =
      LandingPageComponent.selectedChartValue.source === 1
        ? 'Common Datapoints'
        : LandingPageComponent.selectedChartValue.source === 2
          ? 'KPIs'
          : 'Parameters';
    this.getUserList();
    //if(LandingPageComponent.selectedChartValue.source === 2){
    this.KPIId = undefined;
    this.numbersArray = LandingPageComponent.selectedChartValue.sourceValues
      .slice(1, -1)
      .split(',');
    if (this.numbersArray.length === 1) {
      this.KPIId = parseInt(this.numbersArray[0]);
    } else {
      this.getDDBySourceList();
    }
    this.addActionForm?.reset();
    this.addActionForm.get('actionType')?.setValue('Corrective');
    this.addActionForm
      .get('kpi')
      ?.setValue(LandingPageComponent.chartProp.point.series.name);
    this.addStatus = 'Open';
    this.dialog.open(this.addActionModal, { height: 'auto', minWidth: '91%' });
    // }else{
    //   this.toaster.info('info','You can not take action on this ');
    // }
  }

  getUserList(): void {
    this.commonService.getAllEmployess().subscribe(
      (res: any) => {
        console.log(res);
        if (!res.HasError) {
          this.userList = res;
          this.userFilter = this.userList?.slice();
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  //====================================================Add new tab===================================================================//
  addNewTab(obj, TransactionType) {
    // Add a new tab and update the database using the TabsService
    const newTab = {
      tabName:
        obj.data?.TabName !== undefined
          ? obj.data?.TabName
          : this.AddTabform.get('tabName').value,
      TransactionType: TransactionType,
      addedFrom: 'personalized',
      Id: TransactionType === 1 ? 0 : obj.data?.Id,
    };

    this.dynamicService.saveTabsData(newTab).subscribe(
      (res: any) => {
        if (
          res.Table[0].Msg ===
          'c0-Please check with System Administrator you can not add more than one tab'
        ) {
          this.toaster.error(res.Table[0].Msg);
          this.getTabs();
          this.dialog.closeAll();
        } else {
          this.toaster.success(res.Table[0].Msg);
          this.getTabs();
          this.getCardListRight();
          this.dialog.closeAll();
        }
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  confirmDialog(obj): void {
    const message = `Are you sure you want to delete this Dashboard?`;

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      maxWidth: '600px',
      width: '450px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.addNewTab(obj, 3);
      } else {
        console.log(dialogResult);
      }
    });
  }

  getTabs() {
    this.dynamicService.getTabsData().subscribe(
      (data: any) => {
        (this.tabs = data.Table),
          this.tabs.length > 0
            ? (this.IsTabExist = true)
            : (this.IsTabExist = false);
        this.rowData = this.tabs;
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  ngAfterViewInit(): void {
    LandingPageComponent.createActionref = this.createAction;
  }

  // Handle window resize to make charts responsive
  @HostListener('window:resize', ['$event'])
  onWindowResize(event?: any) {
    // Reflow all charts when window is resized
    if (this.chartArrayRight && this.chartArrayRight.length > 0) {
      setTimeout(() => {
        this.chartArrayRight.forEach((chartItem) => {
          if (chartItem.chartOption && chartItem.chartOption.ref) {
            try {
              chartItem.chartOption.ref.reflow();
            } catch (error) {
              console.log('Error reflowing chart:', error);
            }
          }
        });
      }, 100);
    }
  }

  get shouldShowHero(): boolean {
    return this.tabs.length === 0 || (this.selectedTabIndex > 0 && this.DataExist);
  }

  tabSelected(index: number) {
    this.resetList();
    this.selectedTabIndex = index;
    if (index === 1) {
      this.getCardList();
      setTimeout(() => {
        this.getCardListRight();
      }, 3000); // You can adjust the delay as needed
    } else {
      // this.getUserMachineList();
    }
  }
  closeTab(index: number) {
    this.tabs.splice(index, 1);
    // this.tabSelected(this.selectedTabIndex);
  }

  //========================================================= Add Datapoint Source=============================================//
  // getDataPointSourceList() {
  //   this.dynamicService.getDataPointSourceData().subscribe(
  //     (data: any) => {
  //       this.dataPointSources = data.Table;
  //       this.AddCardform.get('source').setValue(this.dataPointSources[0].Id);
  //       if (this.updateCard === true) {
  //         this.AddCardform.get('source').patchValue(this.updateValues.source);
  //         this.sourceName = this.dataPointSources.find(
  //           (val) => val.Id === this.updateValues.source
  //         )?.SourceName;
  //       }
  //       this.getChartList();
  //     },
  //     (err: any) => {
  //       console.log(err);
  //       // this.spinner.hide();
  //     }
  //   );
  // }

  getDataPointSourceList() {
    this.dynamicService.getDataPointSourceData().subscribe(
      (data: any) => {
        this.dataPointSources = data.Table;
        if (this.dataPointSources.length > 0) {
          this.AddCardform.get('source').setValue(this.dataPointSources[0].Id);
          this.sourceName = this.dataPointSources[0].SourceName;
        }
        if (this.updateCard === true) {
          this.AddCardform.get('source').patchValue(this.updateValues.source);
          this.sourceName = this.dataPointSources.find(
            (val) => val.Id === this.updateValues.source
          )?.SourceName;
        }
        this.getChartList();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


  toggleOption(source: any) {
    
    const obj = this.dataPointSources.find((val) => val.Id === source);
    this.sourceName = obj?.SourceName;
    this.sourceId = source;
    this.dynamicListByDatasource = [];
    this.filteredDynamicValues = [];
    this.filteredDataPoints = [];
    this.getChartList();
  }

  getDDBySourceList() {
    const params = {
      group: this.groupSession.groupCode,
      plant: this.plantSession.plantCode,
      unit: this.AddCardform.value.unit === null
       || this.AddCardform.value.unit === undefined 
       || this.AddCardform.value.unit.length === 0 ? "0" 
       : this.AddCardform.value.unit.includes(0)
      ? '0'
      : this.AddCardform.value.unit.join(','),
      line:  this.AddCardform.value.line === null
       || this.AddCardform.value.line === undefined 
       || this.AddCardform.value.line.length === 0 ? "0" : this.AddCardform.value.line.includes(0)
      ? '0'
      : this.AddCardform.value.line.join(','),
      sourceName: this.sourceName,
    };
    this.dynamicService.GetDropdownByDataSourceNameForLandingPage(params).subscribe(
      (data: any) => {
        this.dynamicListByDatasource = data.Table;
        this.filteredDynamicValues = this.dynamicListByDatasource?.slice();
        this.filteredValueMulti.next(this.filteredDynamicValues);
        this.filterValue();
        if (
          this.updateCard === true &&
          this.updateValues?.sourceValues !== null &&
          !this.isChangingDatapoint // Don't override if user is changing datapoint
        ) {
          this.AddCardform.get('values').patchValue(
            JSON.parse(this.updateValues?.sourceValues)
          );
          this.AddCardform.get('labelName').patchValue(
            this.updateValues?.labelName
          );
          this.AddCardform.get('analysisUrl').patchValue(
            this.updateValues?.analysisUrl
          );
          this.AddCardform.get('orderNo').patchValue(
            this.updateValues?.orderNo
          );
          this.AddCardform.get('Id').patchValue(this.updateValues?.Id);
        }
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  getAggregatesList() {
    this.dynamicService.getAggregatesList().subscribe(
      (data: any) => {
        this.AggeregateList = data.Table;
        this.AddCardform.get('aggregates').patchValue(
          this.AggeregateList[0].id
        );
        if (this.updateCard === true) {
          this.AddCardform.get('aggregates').patchValue(
            this.updateValues.aggregates
          );
        }
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  toggleAllSelection() {
    if (this.allSelectedOptions) {
      this.allSelected.options.forEach((item: MatOption) => item.select());
      // this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
      // this.getVariableParameters();
    } else {
      this.allSelected.options.forEach((item: MatOption) => item.deselect());
      // this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
      // this.getVariableParameters();
    }
  }

  onValueChange() {
    let newStatus = true;
    this.allSelected.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
        // this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
        // this.getVariableParameters();
      } else {
        // this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
        // this.getVariableParameters();
      }
    });
    this.allSelectedOptions = newStatus;
  }

  //========================================================== End =========================================================//

  //==========================================================AgGrid======================================================================//
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  rowClicked(params: any) {
    params.node.setData({
      ...params.data,
      dirty: true,
    });
  }

  getMili(Start_Time: any) {
    var date = moment(Start_Time).format(this.format);
    return new Date(date).getTime();
  }

  // Download PDF
  downloadPDF() {
    const chartsContainer = this.container.nativeElement;
    let totalPages = 1; // Initialize total pages
    let currentPage = 1; // Initialize current page
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const topMargin = 20; // Top margin to avoid header overlap
    const maxImageHeight = pageHeight - topMargin - margin; // Adjust max image height
    let contentStartY = topMargin; // Start content below the header

    chartsContainer
      .querySelectorAll('.highcharts-container')
      .forEach((chartElement, index) => {
        const chartSVG = chartElement.querySelector('svg');
        const chartWidth = parseInt(chartSVG.getAttribute('width'), 10);
        const chartHeight = parseInt(chartSVG.getAttribute('height'), 10);
        const aspectRatio = chartWidth / chartHeight;

        // Scale the chart to fit the page width while maintaining aspect ratio
        const scaledWidth = pageWidth - 2 * margin;
        const scaledHeight = scaledWidth / aspectRatio;

        // Convert SVG to canvas
        const canvas = document.createElement('canvas');
        canvas.width = chartWidth;
        canvas.height = chartHeight;
        const context = canvas.getContext('2d');
        const DOMURL = window.URL || window.webkitURL || window;
        const svgData = new XMLSerializer().serializeToString(chartSVG);
        const img = new Image();
        const svgBlob = new Blob([svgData], {
          type: 'image/svg+xml;charset=utf-8',
        });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
          context.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);
          const imageDataURL = canvas.toDataURL('image/png');
          this.addHeader(pdf); // Add header

          // Check if the new content will fit on the current page
          if (contentStartY + scaledHeight > maxImageHeight) {
            pdf.addPage();
            currentPage++;
            totalPages++;
            contentStartY = topMargin; // Reset Y position for new page
            this.addFooter(pdf, currentPage, totalPages); // Add footer
          }

          // Add the image to the PDF
          pdf.addImage(
            imageDataURL,
            'PNG',
            margin,
            contentStartY,
            scaledWidth,
            scaledHeight
          );
          contentStartY += scaledHeight + margin; // Update Y position for next content

          // Save the PDF after the last chart
          if (index === chartsContainer.childElementCount - 1) {
            pdf.save('charts.pdf');
          }
        };

        img.src = url;
      });
  }

  addHeader(pdf) {
    pdf.setFillColor(15, 15, 209); // Grey color; change as needed
    pdf.rect(0, 0, pdf.internal.pageSize.getWidth(), 20, 'F'); // Rectangle for header

    // Set text color and font size
    pdf.setTextColor(255, 255, 255); // White color; change if needed
    pdf.setFontSize(20);

    // Add centered text
    this.centerText('O3, Dynamic Dashboard', 15, pdf);
  }

  addFooter(pdf, pageNumber, totalPages) {
    const date = new Date();
    const formattedDate = `${date.getDate()}/${date.getMonth() + 1
      }/${date.getFullYear()}`;
    pdf.setFontSize(10);
    pdf.text(
      `Page ${pageNumber} of ${totalPages}`,
      10,
      pdf.internal.pageSize.getHeight() - 20
    );
    pdf.text(
      `Date: ${formattedDate}`,
      pdf.internal.pageSize.getWidth() - 40,
      pdf.internal.pageSize.getHeight() - 20
    );
  }

  centerText(text, y, pdf) {
    var textWidth =
      (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    var textOffset = (pdf.internal.pageSize.getWidth() - textWidth) / 2;
    pdf.text(text, textOffset, y);
  }

  // ----------------------------------------------------------resize card code ---------------------------------------------------//
  startResize(event: MouseEvent, card: any) {
    const cardElement = event.target as HTMLElement;
    const containerRect = this.container.nativeElement.getBoundingClientRect();
    const cardRect = cardElement.getBoundingClientRect();

    const initialX = event.clientX;
    const initialWidth = cardRect.width;
    const widthChart = 0;

    const mouseMoveHandler = (e: MouseEvent) => {
      const dx = e.clientX - initialX;
      const newWidth = initialWidth + dx;

      if (newWidth > 0) {
        cardElement.style.width = newWidth + 'px';
        const totalWidth = containerRect.width;
        card.Item.width = (newWidth / totalWidth) * 100;
        card.chartOption?.ref.setSize(newWidth - 50, card.height);
        card.zIndex = 1;
      }
    };

    const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);

    const originalWidth = containerRect.width;
    const originalHeight = containerRect.height;
  }

  toggleMaximize(card) {
    card.Item.isMaximized = true;
    if (card.Item.isMaximized) {
      this.openBottomSheet(card);
    } else {
      card.Item.width = this.lastUpdatedWidth;
    }
  }

  saveLayout(card) {
    this.chartArrayRight.find((item) => item.Item.Id === card.Item.Id).width =
      card.Item.width;
    const params = {
      Id: card.Item.Id,
      width: card.Item.width,
    };
    this.dynamicService.saveLayout(params).subscribe(
      (data: any) => {
        this.toaster.success(data.Table[0].Column1);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  static openActionsModel(obj, elem) {
    LandingPageComponent.selectedChartValue = obj;
    LandingPageComponent.chartProp = elem;
    this.dialog.open(LandingPageComponent.createActionref);
  }

  openRcaDue() {
    const dialogRef = this.dialog.open(AtStagesNcrComponent, {
      height: '100%',
      width: '90%',
      panelClass: 'full-screen-modal',
      data: {
        InitProbStatement: LandingPageComponent.selectedChartValue.labelName,
        moduleId: 5,
        patchForm: 0,
        patchHeader: true,
        Group: this.groupSession.groupCode,
        Plant: LandingPageComponent.selectedChartValue.PlantId,
        headerId: 0,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log('RCA Closed');
      console.log(data);
    });
  }


  openBottomSheet(card: any) {
    let chartOptions = card.chartOption.options; // just the config
    chartOptions = {
      ...chartOptions,
      rangeSelector: {
        ...chartOptions.rangeSelector,  
        inputEnabled: false  
      }
    };
    const chartItemId = `chart-${card.Item.Id}`;

    this.bottomSheet.open(CustomBottomSheetComponent, {
      panelClass: 'my-bottom-sheet',
      data: {
        chartOptions,
        chartItemId,
      },
    });
  }


}
